import { ROUTE_PATHS } from '../config/navigation';
import managedContent from './managedContent.json';

const routePathMap = {
  dashboard: ROUTE_PATHS.dashboard,
  directory: ROUTE_PATHS.directory,
  announcements: ROUTE_PATHS.announcements,
  documents: ROUTE_PATHS.documents,
  surveys: ROUTE_PATHS.surveys,
  innovation: ROUTE_PATHS.innovation,
  events: ROUTE_PATHS.events,
  profile: ROUTE_PATHS.profile
};

const resolvePath = (item) => item.path || routePathMap[item.pathKey] || ROUTE_PATHS.dashboard;

const hydrateOnboardingGuide = (guide) => {
  if (!guide) {
    return null;
  }

  return {
    ...guide,
    steps: (guide.steps || []).map((item) => ({ ...item, path: resolvePath(item) })),
    documents: (guide.documents || []).map((item) => ({ ...item, path: resolvePath(item) }))
  };
};

export const hydrateCorporateContent = (content) => ({
  managementMessages: (content.managementMessages || []).map((item) => ({
    ...item,
    ctaPath: resolvePath(item)
  })),
  cultureHighlights: content.cultureHighlights || [],
  corporateQuickAccess: (content.corporateQuickAccess || []).map((item) => ({
    ...item,
    path: resolvePath(item)
  })),
  quickContacts: content.quickContacts || [],
  systemLinks: content.systemLinks || [],
  participationLinks: (content.participationLinks || []).map((item) => ({
    ...item,
    path: resolvePath(item)
  })),
  onboardingGuide: hydrateOnboardingGuide(content.onboardingGuide)
});

const corporateContent = hydrateCorporateContent(managedContent.corporate);

export const {
  managementMessages,
  cultureHighlights,
  corporateQuickAccess,
  quickContacts,
  systemLinks,
  participationLinks,
  onboardingGuide
} = corporateContent;

export const documentCategories = [
  {
    id: 'all',
    queryValue: 'tum-kaynaklar',
    title: 'Tüm Kaynaklar',
    shortLabel: 'Tümü',
    description: 'Doküman merkezindeki tüm içerikler',
    icon: 'bx bx-grid-alt',
    keywords: []
  },
  {
    id: 'procedures',
    queryValue: 'prosedurler',
    title: 'Prosedürler',
    shortLabel: 'Prosedürler',
    description: 'Kurumsal süreçlerin uygulanma yöntemlerini açıklayan dokümanlar',
    icon: 'bx bx-list-check',
    keywords: ['prosedür', 'prosedur']
  },
  {
    id: 'instructions',
    queryValue: 'talimatlar',
    title: 'Talimatlar',
    shortLabel: 'Talimatlar',
    description: 'Görev ve uygulama adımlarını açıklayan talimatlar',
    icon: 'bx bx-task',
    keywords: ['talimat']
  },
  {
    id: 'process_flows',
    queryValue: 'surec-akislari',
    title: 'Süreç Akışları',
    shortLabel: 'Süreç Akışları',
    description: 'İş akışlarını ve süreç adımlarını gösteren dokümanlar',
    icon: 'bx bx-git-branch',
    keywords: ['süreç akış', 'surec akis', 'iş akış', 'is akis']
  },
  {
    id: 'policies',
    queryValue: 'politikalar',
    legacyQueryValues: ['politika-prosedur'],
    title: 'Politikalar',
    shortLabel: 'Politikalar',
    description: 'Kurumsal politika ve yönetmelikler',
    icon: 'bx bx-shield-quarter',
    keywords: ['politika', 'yönetmelik', 'yonetmelik']
  },
  {
    id: 'quality_manual',
    queryValue: 'kalite-el-kitabi',
    title: 'Kalite El Kitabı',
    shortLabel: 'Kalite El Kitabı',
    description: 'Kalite yönetim sistemine ait el kitabı ve temel dokümanlar',
    icon: 'bx bx-book-open',
    keywords: ['kalite el kitabı', 'kalite el kitabi']
  },
  {
    id: 'corporate_communications',
    queryValue: 'kurumsal-iletisim',
    title: 'Kurumsal İletişim',
    shortLabel: 'Kurumsal İletişim',
    description: 'Kurumsal kimlik, logo, sunum ve iletişim materyalleri',
    icon: 'bx bx-message-rounded-dots',
    keywords: ['kurumsal iletişim', 'kurumsal iletisim']
  },
  {
    id: 'other',
    queryValue: 'diger-dokumanlar',
    legacyQueryValues: ['form-sablon', 'kurumsal-kaynaklar'],
    title: 'Diğer Dokümanlar',
    shortLabel: 'Diğer Dokümanlar',
    description: 'Diğer destekleyici kurumsal dokümanlar',
    icon: 'bx bx-folder',
    keywords: []
  }
];

export const featuredDocumentCollections = [
  {
    id: 'procedures',
    title: 'Prosedürler',
    description: 'Güncel kurumsal prosedürlere erişin.',
    categoryId: 'procedures',
    ctaLabel: 'Prosedürleri görüntüle'
  },
  {
    id: 'policies',
    title: 'Politikalar',
    description: 'Kurumsal politika ve yönetmeliklere erişin.',
    categoryId: 'policies',
    ctaLabel: 'Politikaları görüntüle'
  },
  {
    id: 'quality_manual',
    title: 'Kalite El Kitabı',
    description: 'Kalite yönetim sisteminin temel dokümanlarına erişin.',
    categoryId: 'quality_manual',
    ctaLabel: 'Kalite dokümanlarını görüntüle'
  }
];

export const getCorporateContentFallback = () => ({
  managementMessages: [...managementMessages],
  cultureHighlights: [...cultureHighlights],
  corporateQuickAccess: [...corporateQuickAccess],
  quickContacts: [...quickContacts],
  systemLinks: [...systemLinks],
  participationLinks: [...participationLinks],
  onboardingGuide
});

export default corporateContent;
